// extracted by mini-css-extract-plugin
export default {"container":"AkXLDT","SwitchRoot":"dfv_CP","SwitchThumb":"uNqsVh","Label":"vWMtHG"};